// This file is AUTOGENERATED, do not edit it manually!!!

export const customFields = {
    add_own_options: 'Добавить собственные варианты выбора',
    allActivities: 'Всех типов активностей (задача, проблема, запрос)',
    AllActivities_group_title: 'Поля для всех типов активностей (задача, проблема, запрос)',
    batch_mark_as_optional: 'Пометить как опциональные',
    batch_mark_as_required: 'Пометить как обязательные',
    boolean_field_type: 'Флажок (да/нет)',
    create_cf: 'Создать дополнительное поле',
    custom_field_could_not_be_deleted: 'Поле \"{0}\" не может быть удалено',
    custom_field_could_not_be_removed: 'Поле \"{0}\" не может быть удалено',
    custom_field_readonly_warning: 'Вы можете только просматривать это поле с вашим уровнем доступа. Чтобы внести изменения, свяжитесь с администратором.',
    customer: 'Заказчиков',
    Customer_group_title: 'Поля для заказчиков',
    default_field_name: 'Новое поле',
    delete_field_title: 'Удалить дополнительное поле \"{0}\"?',
    everywhere: 'Везде',
    expense: 'Затрат',
    Expense_group_title: 'Поля для затрат',
    field_is_used_in_formula: '1#Это поле используется в поле формулы {0}#Это поле используется в полях формул: {0}',
    field_non_editable_portfolio_restriction: 'Это поле недоступно для проектов в портфолио <b>{0}</b>',
    field_non_editable_without_portfolio_restriction: 'Это поле недоступно для проектов <b>{0} без портфолио</b>',
    field_non_editable_wrong_space: 'Это поле не включено в рабочее пространство <b>{0}</b>',
    fields_plural: '1#{0} поле#{0} поля',
    formula_description: 'Для создания формулы вы можете использовать числовые, денежные и часовые поля, а также операции + - * / . Вы также  можете добавлять скобки:',
    formula_example: 'Например:',
    formula_field_type: 'Формула',
    formula_function_description: 'Вы также можете использовать рабочие дни для расчета разницы между двумя датами в рабочих днях.',
    hyperlink_field_type: 'Cсылка',
    issue: 'Проблем',
    Issue_group_title: 'Поля для проблем',
    limitReachedMessage: 'Извините, вы достигли лимита добавления дополнительных полей выбранного типа.',
    mark_as_optional_feedback: '7#{0} настраиваемое поле успешно отмечено как опциональное#{0} настраиваемых поля успешно отмечены как опциональные#{0} настраиваемых полей успешно отмечены как опциональные',
    mark_as_optional_feedback_failure: '7#{0} настраиваемое поле не удалось пометить как опциональное из-за его типа (выпадающий список, формула или флажок)#{0} настраиваемых поля не удалось пометить как опциональные из-за их типа (выпадающий список, формула или флажок)#{0} настраиваемых полей не удалось пометить как опциональные из-за их типа (выпадающий список, формула или флажок)',
    mark_as_required_feedback: '7#{0} настраиваемое поле успешно отмечено как обязательное#{0} настраиваемых поля успешно отмечены как обязательные#{0} настраиваемых полей успешно отмечены как обязательные',
    mark_as_required_feedback_failure: '7#{0} настраиваемое поле не удалось пометить как обязательное из-за его типа (выпадающий список, формула или флажок)#{0} настраиваемых поля не удалось пометить как обязательные из-за их типа (выпадающий список, формула или флажок)#{0} настраиваемых полей не удалось пометить как обязательные из-за их типа (выпадающий список, формула или флажок)',
    msg_deleteUsedValue: 'Это значение используется в {0} {1}',
    msg_entities_portfolioRemoved: 'Данное дополнительное поле будет недоступным для выбранной сущности, входящих в исключенные портфолио.',
    msg_entities_spaceRemoved: 'Данное дополнительное поле будет недоступным для выбранной сущности, входящих в исключенные пространства.',
    msg_lead_to: 'Сохранить изменения?',
    msg_restrictionsAdded: 'Данное дополнительное поле будет являться ассоциированным с портфолио.',
    msg_restrictionsRemoved: 'Данное дополнительное поле не будет более являться ассоциированным с портфолио.',
    msg_unportfolioedOff: 'Данное поле будет недоступно для проектов, не включенных в портфолио.',
    msg_valueRemoved: 'Элементы, исключенные из списка, будут удалены навсегда.',
    no_portfolio: 'Без портфолио',
    nowhere: 'Нигде',
    numeric_field_type: 'Число',
    other_portfolios: 'Другие портфолио',
    portfolio: 'Портфолио',
    Portfolio_group_title: 'Поля для портфолио',
    project: 'Проектов',
    Project_group_title: 'Поля для проектов',
    readonly_warning_no_access_to_portfolios: 'Вы можете только просматривать это поле, поскольку оно связано с портфолио, к которым у вас нет доступа.',
    remove_field_description: 'Поле по-прежнему будет доступно в настройках компании.',
    remove_field_title: 'Хотите удалить поле \"{0}\" из \"{1}\"?',
    request: 'Запросов',
    Request_group_title: 'Поля для запросов',
    required_fileds_not_filled: '7#{0} обязательное поле не заполнено#{0} обязательных поля не заполнены#{0} обязательных полей не заполнено',
    select_from: 'Выбрать поле',
    spaces_field_label: 'Рабочие пространства',
    spaces_field_section_title: 'Доступно в рабочих пространствах',
    task: 'Задач',
    Task_group_title: 'Поля для задач',
    text_add_new_item: 'Добавьте новый элемент или используйте Ctrl+V для вставки списка',
    text_add_portfolio: 'Добавить портфолио',
    text_addDescription: 'Добавить описание',
    text_all_objects: 'Всех объектов',
    text_available_in: 'Доступно для следующих портфолио',
    text_create_new_field: 'Добавить поле',
    text_currentIdentity: 'Начальное значение',
    text_custom_field_for: 'Поле для',
    text_delete: 'Удалить поле',
    text_delete_permanently: 'Удалить навсегда',
    text_deleteValue: 'Удалить значение',
    text_edit: 'Редактировать поле',
    text_empty_page_part1: 'Вам нужны дополнительные возможности, чтобы отслеживать и группировать Ваши данные?',
    text_empty_page_part2: 'Добавляйте свои собственные поля для проектов, задач, пользователей и не только...',
    text_error_title: 'Невозможно завершить операцию',
    text_field_type: 'Текст',
    text_fieldName: 'Название поля',
    text_fieldType: 'Тип поля',
    text_filter: 'Дополнительные поля для',
    text_include_in_unportfolioed_projects: 'Также показывать в проектах, не включенных в портфолио',
    text_isIdentity: 'Автоприращение',
    text_isNumeric: 'Только целые числа',
    text_isRequired: 'Обязательное поле',
    text_place_plural: '1#месте#местаx',
    text_remainingValuesTemplate: 'Показать \"{0}\" скрытых значений от начала списка.',
    text_remove: 'Удалить',
    text_restricted_by_portfolio: 'Ограничить по портфолио',
    text_set_restrictions: 'Показывать поле только для проектов, включенных в определенные портфолио',
    textarearich_field_type: 'Параграф (с форматированием)',
    timeEntry: 'Тайм логов',
    TimeEntry_group_title: 'Поля для тайм логов',
    tooltip_disable_batch: 'Вы можете просмотреть поле только с вашим уровнем доступа. Для внесения изменений свяжитесь с администратором.',
    tooltip_everywhere: '<b>Везде</b> — настраиваемое поле не имеет ограничений видимости.',
    tooltip_nowhere: '<b>Нигде</b> — настраиваемое поле нигде не включено.',
    tooltip_other_portfolios: '<b>Другие портфолио</b> – относится к портфолио, для доступа к которым у вас нет необходимых разрешений.',
    tooltip_portfolio_and_without_part1: '<b>Имя портфолио, </b>',
    tooltip_portfolio_and_without_part2: '<b>Без портфолио</b> — настраиваемое поле включается в объекты в выбранных портфолио и в объекты без портфолио.',
    tooltip_portfolio_name: '<b>Имя портфолио</b> — настраиваемое поле включено в выбранные портфолио.',
    tooltip_without_portfolio: '<b>Без портфолио</b> — настраиваемое поле включается в объекты без портфолио.',
    unknown_portfolio_description: 'Портфолио к которому у вас нет доступа.',
    upgradeToEnterpriseMessage: 'К сожалению, вы достигли предела для Team версии {brandName}. Пожалуйста, <a href=\"{licenseUrl}\" target=\"_blank\">обновитесь</a> до {brandName} Enterprise.',
    use_cfs_options: 'Использовать пользовательское поле как источник вариантов',
    use_own_options: 'Редактировать собственные варианты выбора',
    user: 'Пользователей',
    User_group_title: 'Поля для пользователей',
    validation_error_InvalidBracketsNumber: 'Неправильное использование круглых скобок',
    validation_error_InvalidField: 'Введено недопустимое поле. Поле \"{0}\" не существует',
    validation_error_InvalidOperation: 'Недопустимые математических операций. Разрешены только операторы ‘+’, ‘-’, ‘*’, и ‘/’',
    validation_error_InvalidSymbol: 'Недопустимое использование символов',
    validation_error_MismatchedArgumentType: 'Только даты могут использоваться в качестве аргументов для функции $WORKING_DAYS.',
    validation_error_MismatchedInput: 'Неполная формула. Убедитесь, что указаны все символы и операторы для создания корректной формулы',
    validation_error_MismatchedOperandType: 'Поля даты не могут использоваться в арифметических операциях. Используйте функцию $WORKING_DAYS(@Date1, @Date2) для работы с ними.',
    validation_error_MismatchedReturnType: 'Поля даты не могут использоваться в арифметических операциях. Используйте функцию $WORKING_DAYS(@Date1, @Date2) для работы с ними.',
    validation_error_Unknown: 'Недопустимый формат формулы. Введенная вами формула имеет недопустимый формат и не может быть успешно проанализирована',
    visibility_title: 'Видимость',
    warning_linked_global_field_activities: 'Изменения этого поля повлияют на задачи в нескольких рабочих пространствах.',
    warning_linked_global_field_expenses: 'Изменения этого поля повлияют на затраты в нескольких рабочих пространствах.',
    warning_linked_global_field_projects: 'Изменения этого поля повлияют на проекты в нескольких рабочих пространствах.',
    warning_linked_global_field_time: 'Изменения этого поля повлияют на записи времени в нескольких рабочих пространствах.',
    warning_wont_visible_without_space: 'Дополнительное поле не будет видно для пользователей пока оно не будет добавлено в рабочее пространство.',
};
